<section class="disb-cancellation-queue" aria-labelledby="disbCancellationQueueTitle">
  <header class="disb-cancellation-queue-header">
    <div>
      <h5 id="disbCancellationQueueTitle" class="disb-cancellation-queue-heading">
        คิวยกเลิกกลุ่มใบปะหน้า
      </h5>
      <p class="disb-cancellation-queue-description">
        ตรวจสอบคำขอแก้ไขที่กระทบใบปะหน้าซึ่งออกแล้ว ก่อนยกเลิกกลุ่มในระบบ
      </p>
    </div>
    <div class="disb-cancellation-queue-header-actions">
      <span class="disb-cancellation-queue-count" aria-live="polite">
        รอดำเนินการ {{ summaryCount() }} รายการ
      </span>
      <button
        type="button"
        class="btn btn-outline-secondary disb-cancellation-refresh-button"
        [disabled]="tableLoading() || actionLoading()"
        (click)="onRefresh()"
      >
        <span *ngIf="tableLoading()" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
        รีเฟรช
      </button>
    </div>
  </header>

  <div *ngIf="errorMessage()" class="alert alert-danger disb-cancellation-error" role="alert">
    {{ errorMessage() }}
  </div>

  <div *ngIf="tableLoading()" class="disb-cancellation-loading" role="status" aria-live="polite">
    <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
    กำลังโหลดคิวยกเลิกใบปะหน้า...
  </div>

  <p *ngIf="!tableLoading() && requirements().length === 0 && !errorMessage()" class="disb-cancellation-empty">
    ไม่มีคำขอที่รอการยกเลิกใบปะหน้า
  </p>

  <ul *ngIf="!tableLoading() && requirements().length > 0" class="disb-cancellation-list">
    <li *ngFor="let requirement of requirements(); trackBy: trackRequirement" class="disb-cancellation-card">
      <div class="disb-cancellation-card-head">
        <div>
          <h6 class="disb-cancellation-card-title">
            คำขอแก้ไข #{{ requirement.correction_request_id ?? requirement.id }}
            <span class="disb-cancellation-status">{{ statusLabel(requirement) }}</span>
          </h6>
          <p class="disb-cancellation-card-meta">
            ผู้ยื่นคำขอ: {{ requesterName(requirement) }}
            <span aria-hidden="true">·</span>
            ส่งคำขอเมื่อ {{ requestedAt(requirement) }}
          </p>
        </div>
        <button
          type="button"
          class="btn btn-outline-primary disb-cancellation-view-button"
          (click)="onView(requirement)"
        >
          ดูรายละเอียด
        </button>
      </div>

      <p class="disb-cancellation-reason">
        <strong>เหตุผล:</strong> {{ displayValue(requirement.reason ?? requirement.description) }}
      </p>

      <div class="disb-cancellation-card-figures" aria-label="สรุปเอกสารที่กระทบ">
        <span><strong>{{ requirement.items?.length ?? 0 }}</strong> รายวิชาที่กระทบ</span>
        <span><strong>{{ requirement.affected_certifications?.length ?? 0 }}</strong> ใบรับรอง</span>
        <span><strong>{{ (requirement.summary ?? requirement.cancellation_summary)?.total ?? requirement.cover_memos?.length ?? 0 }}</strong> กลุ่มใบปะหน้า</span>
      </div>
    </li>
  </ul>

  <app-table-pagination
    *ngIf="!tableLoading() && total() > 0"
    [page]="page()"
    [limit]="limit()"
    [total]="total()"
    [totalPage]="totalPages()"
    [offset]="(page() - 1) * limit()"
    [dataLength]="requirements().length"
    [pageSizeOptions]="pageSizeOptions"
    ariaLabel="คิวยกเลิกกลุ่มใบปะหน้า"
    (pageChange)="onPageChange($event)"
    (limitChange)="onLimitChange($event)"
  ></app-table-pagination>
</section>

<div *ngIf="detailOpen()" class="disb-cancellation-modal-overlay" role="presentation">
  <div
    class="disb-cancellation-modal-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="disbCancellationDetailTitle"
  >
    <ng-container *ngIf="selectedRequirement() as requirement">
      <header class="disb-cancellation-modal-header">
        <div>
          <h5 id="disbCancellationDetailTitle">
            รายละเอียดคำขอแก้ไข #{{ requirement.correction_request_id ?? requirement.id }}
          </h5>
          <span class="disb-cancellation-status">{{ statusLabel(requirement) }}</span>
        </div>
        <button
          type="button"
          class="btn-close"
          aria-label="ปิดรายละเอียดคำขอ"
          [disabled]="actionLoading()"
          (click)="onCloseDetail()"
        ></button>
      </header>

      <div class="disb-cancellation-modal-body">
        <div *ngIf="errorMessage()" class="alert alert-danger" role="alert">
          {{ errorMessage() }}
        </div>

        <section class="disb-cancellation-detail-section">
          <h6>ข้อมูลคำขอ</h6>
          <dl class="disb-cancellation-detail-grid">
            <div>
              <dt>ผู้ยื่นคำขอ</dt>
              <dd>{{ selectedRequester }}</dd>
            </div>
            <div>
              <dt>ส่งคำขอเมื่อ</dt>
              <dd>{{ requestedAt(requirement) }}</dd>
            </div>
            <div class="disb-cancellation-detail-wide">
              <dt>เหตุผลการแก้ไข</dt>
              <dd class="disb-cancellation-pre-line">{{ selectedReason }}</dd>
            </div>
          </dl>
        </section>

        <section class="disb-cancellation-detail-section">
          <h6>รายวิชาที่กระทบ</h6>
          <p *ngIf="selectedSubjects.length === 0" class="disb-cancellation-muted">ไม่พบข้อมูลรายวิชา</p>
          <ul *ngIf="selectedSubjects.length > 0" class="disb-cancellation-detail-list">
            <li *ngFor="let subject of selectedSubjects">
              <strong>{{ subject.code }}</strong>
              <span>{{ subject.name }}</span>
              <span *ngIf="subject.section !== '-'">Section {{ subject.section }}</span>
            </li>
          </ul>
        </section>

        <section class="disb-cancellation-detail-section">
          <h6>ใบรับรองที่กระทบ</h6>
          <p *ngIf="selectedCertifications.length === 0" class="disb-cancellation-muted">ไม่พบข้อมูลใบรับรอง</p>
          <ul *ngIf="selectedCertifications.length > 0" class="disb-cancellation-detail-list">
            <li *ngFor="let certification of selectedCertifications">
              <strong>{{ certificationLabel(certification) }}</strong>
              <span>{{ displayValue(certification.teacher_name) }}</span>
              <span>ใบปะหน้า {{ certificationMemoNumber(certification) }}</span>
              <span>{{ displayValue(certification.status_label ?? certification.status_code) }}</span>
            </li>
          </ul>
        </section>

        <section class="disb-cancellation-detail-section">
          <h6>กลุ่มใบปะหน้าที่ต้องยกเลิก</h6>
          <p class="disb-cancellation-group-warning">
            การยกเลิกทำในระดับกลุ่ม สมาชิกทั้งหมดในกลุ่มที่แสดงด้านล่างจะถูกนำออกจากกลุ่มเดิม
            และประวัติเอกสารจะยังคงอยู่เพื่อการตรวจสอบย้อนหลัง
          </p>
          <p *ngIf="selectedCoverMemos.length === 0" class="disb-cancellation-muted">ไม่พบกลุ่มใบปะหน้า</p>
          <ul *ngIf="selectedCoverMemos.length > 0" class="disb-cancellation-detail-list">
            <li *ngFor="let memo of selectedCoverMemos">
              <strong>{{ memoNumber(memo) }}</strong>
              <span>{{ displayValue(memo.department_name) }}</span>
              <span>{{ displayValue(memo.status_label ?? memo.status_code) }}</span>
              <span class="disb-cancellation-memo-state" [class.disb-cancellation-memo-state-cancelled]="memoIsCancelled(memo)">
                {{ memoStatusLabel(memo) }}
              </span>
            </li>
          </ul>
        </section>

        <section class="disb-cancellation-summary" aria-label="สรุปการยกเลิก">
          <span>ทั้งหมด {{ selectedSummary.total }} กลุ่ม</span>
          <span>รอยกเลิก {{ selectedSummary.pending }} กลุ่ม</span>
          <span>ยกเลิกแล้ว {{ selectedSummary.cancelled }} กลุ่ม</span>
        </section>
      </div>

      <footer class="disb-cancellation-modal-footer">
        <span class="disb-cancellation-notice">
          การยืนยันนี้เป็นการยกเลิก workflow ในระบบ ไม่ใช่การคืนเงินหรือย้อนการจ่าย
        </span>
        <button
          type="button"
          class="btn btn-outline-secondary"
          [disabled]="actionLoading()"
          (click)="onCloseDetail()"
        >
          ปิด
        </button>
        <button
          *ngIf="canConfirm(requirement)"
          type="button"
          class="btn btn-primary disb-cancellation-confirm-button"
          [disabled]="actionLoading()"
          (click)="onOpenConfirm()"
        >
          ยืนยันการยกเลิก
        </button>
      </footer>
    </ng-container>
  </div>
</div>

<app-confirm-dialog
  #confirmDialog
  modalId="disbursementCancellationConfirmDialog"
  icon="warning"
  title="ยืนยันการยกเลิกกลุ่มใบปะหน้า"
  [message]="confirmationMessage"
  cancelText="กลับไปตรวจสอบ"
  confirmText="ยืนยันการยกเลิก"
  [isProcessing]="actionLoading()"
  [stackAboveModal]="true"
  (confirmed)="onConfirmCancellation()"
></app-confirm-dialog>
